module.exports = __webpack_public_path__ + "ffa62b144966b7190db99d7034f2615f.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-48.svg
// module id = 581
// module chunks = 0